import React, { useState, useEffect, useCallback, useRef } from 'react';
import './FinalizarVenda.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, message, Spin } from 'antd';
import PaymentScreen from './Pagamento/PaymentScreen';
import Pagamento from './Pagamento/Pagamento';
import axios from 'axios';
import Parametros from './Parametros';
import AcresDesc from './AcresDec/AcrescimoDescontoTotal';
import AcrescimoDescontoTotal from './AcresDec/AcrescimoDescontoTotal';
import IdentificarConsumidor from './FinalizarVenda/IdentificarConsumidor';
import { useConfigQuery } from '../../../queries/useConfig';
import axiosInstance from '../../../axiosInterceptor';
import { api } from '../../../config/api';

const FinalizarVenda = ({
  consumidorIdentificado,
  setConsumidorIdentificado,
  closeModal,
  nomeCupom,
  documentoCupom,
  setNomeCupom,
  setDocumentoCupom,
  consumidor,
  setConsumidor,
  precoTotal,
  pagamentoConcluido,
  setPagamentoConcluido,
  pagamentos,
  setPagamentos,
  produtos,
  setProdutos,
  subTotal,
  CalcularTotais,
  acresDescFrete,
  setAcresDescFrete,
  totalDescontos,
  totalAcrescimos,
  acresDescFreteConcluido,
  setAcresDescFreteConcluido,
  setPagItem,
  pagItem,
  travarAcrescimoDescFrete,
  cpfIntegracao,
  consumidorIntegrado,
  tokenPedidoTechsapp,
  setTokenPedidoTechsapp,
  formasDePagamento,
  idVendedorOrcamento,
  idOrcamento,
  setVendaPuxada,
  setIdPedidoMkt,
  idPedidoMkt,
  focarCodigoDeBarras,
  setMensagemTela
}) => {
  const { data: config, error } = useConfigQuery();
  const [isModalVisibleConsumidor, setIsModalVisibleConsumidor] = useState(false);
  const [isModalVisibleParametros, setIsModalVisibleParametros] = useState(false);
  const [isModalVisiblePagamento, setIsModalVisiblePagamento] = useState(false);
  const [isModalVisibleAcresDesc, setIsModalVisibleAcresDesc] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loja, setLoja] = useState('');
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const [serieDefault, setSerieDefault] = useState('');
  const [indPag, setIndPag] = useState('0');
  const [emailNota, setEmailNota] = useState('');
  const [telefoneEnvio, setTelefoneEnvio] = useState('');
  const [processamentoMsg, setProcessamentoMsg] = useState('');
  const [totalPago, setTotalPago] = useState(0);

  const [parametros, setParametros] = useState({
    infCpl: ''
  });
  const [mostrarCobranca, setMostrarCobranca] = useState(false);
  useEffect(() => {
    console.log(produtos);
  }, [produtos])


  const jaRodouRef = useRef(false);

  useEffect(() => {
    const run = async () => {
      if (!idPedidoMkt) return;
      if (jaRodouRef.current) return;

      jaRodouRef.current = true;
      await emitirCupomNFE();
    };

    run();
  }, [idPedidoMkt]);


  const toggleModalIdentificarConsumidor = () => {
    setIsModalVisibleConsumidor(!isModalVisibleConsumidor);
  };

  const toggleModalParametros = () => {
    setIsModalVisibleParametros(!isModalVisibleParametros);
  };

  const toggleModalPagamento = () => {
    setIsModalVisiblePagamento(!isModalVisiblePagamento);
  };

  const toggleModalAcresDesc = () => {
    setIsModalVisibleAcresDesc(!isModalVisibleAcresDesc);
  };

  const [
    acrescimoDescontosFreteConcluido,
    setAcrescimoDescontosFreteConcluido,
  ] = useState(false);



  function fmt2(v) { return Number(v).toFixed(2); }
  function fmt3(v) { return Number(v).toFixed(3); }

  function calcularVBCDefault(produto) {
    return (produto.quantidade * produto.preco) +
      (produto.valorAcrescimo || 0) -
      (produto.valorDesconto || 0);
  }

  function buildPIS(produto, vBCOverride) {
    const cst = String(produto.cstPis ?? '01').padStart(2, '0');
    const out = { CST_pis: cst };

    // PIS não tributado – só CST
    if (['04', '06', '07', '08', '09', '49', '03', '99'].includes(cst)) return out;

    // CST 01/02 (alíquota %)
    if (cst === '01' || cst === '02') {
      const vBC = vBCOverride != null
        ? Number(vBCOverride)
        : Number(produto.vBC_pis) || calcularVBCDefault(produto);

      const p = Number(produto.ppis);
      const v = produto.vPIS != null ? Number(produto.vPIS) : vBC * (p / 100);

      return {
        ...out,
        vBC_pis: fmt2(vBC),
        pPIS: fmt2(p),
        vPIS: fmt2(v),
      };
    }
    /*
      // CST 03 (quantidade)
      if (cst === '03') {
        const q = Number(produto.qBCProd_pis || produto.quantidade);
        const vAliq = Number(produto.vAliqProd_pis);
        const v = produto.vPIS != null ? Number(produto.vPIS) : q * vAliq;
    
        return {
          ...out,
          qBCProd_pis: fmt3(q),
          vAliqProd_pis: fmt2(vAliq),
          vPIS: fmt2(v),
        };
      }
    
      // CST 99 (outras operações)
      if (cst === '99') {
        const p = Number(produto.ppis);
        const temPercentual = p > 0;
    
        if (temPercentual) {
          const vBC = vBCOverride != null
            ? Number(vBCOverride)
            : Number(produto.vBC_pis) || calcularVBCDefault(produto);
          const v = produto.vPIS != null ? Number(produto.vPIS) : vBC * (p / 100);
    
          return {
            ...out,
            vBC_pis: fmt2(vBC),
            pPIS: fmt2(p),
            vPIS: fmt2(v),
          };
        } else {
          const q = Number(produto.qBCProd_pis || produto.quantidade);
          const vAliq = Number(produto.vAliqProd_pis);
          const v = produto.vPIS != null ? Number(produto.vPIS) : q * vAliq;
    
          return {
            ...out,
            qBCProd_pis: fmt3(q),
            vAliqProd_pis: fmt2(vAliq),
            vPIS: fmt2(v),
          };
        }
      }
    */
    // Demais CST
    return out;
  }


  const buildIBSCBS = (produto, vBc, vIBSUF_ttnfe, vIBSMun_ttnfe, vCBS_ttnfe) => {
    console.log(produto);
    const toNumber = (v) => {
      if (v === null || v === undefined || v === '') return 0;
      const s = String(v).trim().replace(/\s/g, '');
      const norm =
        s.includes(',') && s.includes('.')
          ? s.replace(/\./g, '').replace(',', '.')
          : s.includes(',') && !s.includes('.')
            ? s.replace(',', '.')
            : s;
      const n = Number(norm);
      return Number.isFinite(n) ? n : 0;
    };

    const fmt2 = (n) => toNumber(n).toFixed(2);
    const fmt4 = (n) => toNumber(n).toFixed(4);

    const qtd = toNumber(produto?.quantidade ?? 1);
    const preco = toNumber(produto?.preco ?? 0);

    const acrescimo = toNumber(produto?.valorAcrescimo ?? produto?.acrescimo ?? 0);
    const desconto = toNumber(produto?.valorDesconto ?? produto?.desconto ?? 0);
    const frete = toNumber(produto?.frete ?? 0);

    const vBC_num = preco * qtd + acrescimo + frete - desconto;

    const pIBSUF_num = toNumber(produto?.pibsuf ?? 0);
    const pIBSMun_num = toNumber(produto?.pibsMun ?? 0);
    const pCBS_num = toNumber(produto?.pcbs ?? 0);

    const vIBSUF_num = vBc * (pIBSUF_num / 100);
    const vIBSMun_num = vBc * (pIBSMun_num / 100);
    const vIBS_num = vIBSUF_num + vIBSMun_num;
    const vCBS_num = vBc * (pCBS_num / 100);

    const CST = produto?.ibscbsCst;
    const cClassTrib = produto?.cclassTrib;
    vIBSMun_ttnfe += vIBSMun_num;
    vIBSUF_ttnfe += vIBSUF_num;
    vCBS_ttnfe += vCBS_num;

    return {
      IBSCBS: {
        CST,
        cClassTrib,
        gIBSCBS: {
          vBC: fmt2(vBC_num),
          gIBSUF: {
            pIBSUF: fmt4(pIBSUF_num),
            vIBSUF: fmt2(vIBSUF_num),
          },
          gIBSMun: {
            pIBSMun: fmt4(pIBSMun_num),
            vIBSMun: fmt2(vIBSMun_num),
          },
          vIBS: fmt2(vIBS_num),
          gCBS: {
            pCBS: fmt4(pCBS_num),
            vCBS: fmt2(vCBS_num),
          },
        },
      },
    };
  };


  function buildCOFINS(produto, vBCOverride) {
    const cst = String(produto.cstCofins ?? '01').padStart(2, '0');
    const out = { CST_cofins: cst };

    // COFINS não tributado – só CST
    if (['04', '06', '07', '08', '09', '49', '03', '99'].includes(cst)) return out;

    // 01/02 – alíquota percentual
    if (cst === '01' || cst === '02') {
      const vBC = vBCOverride != null
        ? Number(vBCOverride)
        : Number(produto.vBC_cofins) || calcularVBCDefault(produto);

      const p = Number(produto.pcofins);
      const v = produto.vCOFINS != null ? Number(produto.vCOFINS) : vBC * (p / 100);

      return {
        ...out,
        vBC_cofins: fmt2(vBC),
        pCOFINS: fmt2(p),
        vCOFINS: fmt2(v),
      };
    }
    /*
      // 03 – por quantidade
      if (cst === '03') {
        const q = Number(produto.qBCProd_cofins || produto.quantidade);
        const vAliq = Number(produto.vAliqProd_cofins);
        const v = produto.vCOFINS != null ? Number(produto.vCOFINS) : q * vAliq;
    
        return {
          ...out,
          qBCProd_cofins: fmt3(q),
          vAliqProd_cofins: fmt2(vAliq),
          vCOFINS: fmt2(v),
        };
      }
    
      // 99 – outras operações (percentual OU quantidade)
      if (cst === '99') {
        const p = Number(produto.pcofins);
        const temPercentual = p > 0;
    
        if (temPercentual) {
          const vBC = vBCOverride != null
            ? Number(vBCOverride)
            : Number(produto.vBC_cofins) || calcularVBCDefault(produto);
          const v = produto.vCOFINS != null ? Number(produto.vCOFINS) : vBC * (p / 100);
    
          return {
            ...out,
            vBC_cofins: fmt2(vBC),
            pCOFINS: fmt2(p),
            vCOFINS: fmt2(v),
          };
        } else {
          const q = Number(produto.qBCProd_cofins || produto.quantidade);
          const vAliq = Number(produto.vAliqProd_cofins);
          const v = produto.vCOFINS != null ? Number(produto.vCOFINS) : q * vAliq;
    
          return {
            ...out,
            qBCProd_cofins: fmt3(q),
            vAliqProd_cofins: fmt2(vAliq),
            vCOFINS: fmt2(v),
          };
        }
      }
    */
    // Demais CST
    return out;
  }


  const criarEvento = async (venda) => {
    setProcessamentoMsg('Gerando documentos fiscais...');
    let erroBol = false;
    console.log('dentro do criarEvento');

    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken, // Certifique-se de definir `accessToken`
      },
    };

    try {
      const response = await axios.post(
        `${api.techspdv}/v1/pdveventos/venda`,
        venda,
        options
      );

      if (response.data) {
        console.log('Requisição bem-sucedida');
        await deletarLog(venda.InfoSistema.chaveDocFiscal);
        return response;
      }
    } catch (error) {
      erroBol = true;

      // Tratamento de erro
      if (error.response) {
        console.log('Status de erro:', error.response.status);
        console.log('Dados de erro:', error.response.data);

        const retry = window.confirm(
          'Falha ao gravar o histórico. Deseja tentar novamente?'
        );

        if (retry) {
          console.log('Tentar novamente');
          return await criarEvento(venda);
        } else {
          console.log('Usuário escolheu não tentar novamente.');
          // Realizar ações adicionais se o usuário escolher não tentar novamente
          setLoading(false);
          closeModal();
          setProdutos([]);
          setConsumidor(null);
          setNomeCupom('');
          setDocumentoCupom('');
          setConsumidorIdentificado(false);
          return null;
        }
      }

      console.error('Erro inesperado:', error);
      return null;
    }
  };

  function formatarTelefone(numero) {
    const apenasNumeros = numero.replace(/\D/g, '');

    if (apenasNumeros.length === 13) {
      // Ex: 55 11 91234-5678
      return `+${apenasNumeros.slice(0, 2)} (${apenasNumeros.slice(2, 4)}) ${apenasNumeros.slice(4, 9)}-${apenasNumeros.slice(9)}`;
    } else if (apenasNumeros.length === 11) {
      // Ex: 11 91234-5678
      return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 7)}-${apenasNumeros.slice(7)}`;
    } else if (apenasNumeros.length === 10) {
      // Ex: 11 1234-5678
      return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 6)}-${apenasNumeros.slice(6)}`;
    } else {
      // Retorna o número cru se não casar
      return numero;
    }
  }

  const gravarLog = async (venda, response) => {

    try {

      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      const body = {
        lojaId: config.restaurante.id,
        log: JSON.stringify(venda),
        numeroNota: venda.InfoSistema.numeroDocFiscal,
        chaveNota: venda.InfoSistema.chaveDocFiscal
      }

      const response = await axios.post(
        `${api.techspdv}/v1/logs`, body,
        options
      );

      console.log(response.data);

    } catch (error) {
      console.error('Erro ao acessar o localStorage:', error);
    }
  }
  const deletarLog = async (chaveNota) => {
    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };
      const response = await axios.delete(
        `${api.techspdv}/v1/logs/chave/${chaveNota}`,
        options
      );
      console.log(response.data);
    } catch (error) {
      console.error('Erro ao acessar o localStorage:', error);
    }
  }

  const sharingPdf = async (chaveDocFiscal, modelo) => {
    console.log(chaveDocFiscal);

    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      const response = await axios.get(
        `${api.technfe}/v1/historico/chave/${chaveDocFiscal}`,
        options
      );

      // Decodifica o PDF base64 para um blob
      const pdfBase64 = response.data._embedded.historico[0].pdfBase64;
      const binaryData = atob(pdfBase64);
      const byteNumbers = new Uint8Array(
        binaryData.split('').map((char) => char.charCodeAt(0))
      );
      const blob = new Blob([byteNumbers], { type: 'application/pdf' });

      // Cria uma URL para o blob e inicia o download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${modelo}_${chaveDocFiscal}.pdf`;
      document.body.appendChild(link);
      link.click();

      // Remove o link da DOM
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao carregar historico:', error);
    }
  };

  function downloadBlob(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'documento.xml';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  const baixarXmlComoTexto = async (xmlUrl) => {
    const res = await fetch(xmlUrl, {
      method: "GET",
      // às vezes precisa mandar Accept
      headers: { Accept: "application/xml,text/xml,*/*" },
    });

    const contentType = res.headers.get("content-type") || "";
    const bodyText = await res.text();

    // validação simples pra não mandar HTML achando que é XML
    const pareceXml = bodyText.trim().startsWith("<?xml") || bodyText.includes("<NFe") || bodyText.includes("<nfeProc");
    if (!pareceXml) {
      throw new Error(
        `Resposta não parece XML. content-type=${contentType}. Provável HTML/login/erro.`
      );
    }

    return bodyText;
  }
  const downloadXmlViaIframe = async (xmlUrl) => {
    if (!xmlUrl) return;

    // cria iframe escondido
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = xmlUrl;

    // opcional: limpar depois de alguns segundos
    const cleanup = () => {
      setTimeout(() => {
        try { document.body.removeChild(iframe); } catch { }
      }, 15000);
    };

    iframe.onload = cleanup; // nem sempre dispara por cross-origin, mas não tem problema
    document.body.appendChild(iframe);
  }


  function sanitizeInfAdProd(text) {
    return String(text || "")
      .replace(/[\u0000-\u001F\u007F]/g, " ") // remove caracteres de controle
      .replace(/[<>&]/g, " ")                 // evita quebrar XML
      .replace(/\s+/g, " ")                   // normaliza espaços
      .trim()
      .slice(0, 500);                         // respeita limite do schema
  }
  function trataXProd(str1, str2) {
    const maxLen = 119;

    // normaliza entradas e remove quebras de linha
    str1 = String(str1 || "").replace(/[\r\n]+/g, " ").trim();
    str2 = String(str2 || "").replace(/[\r\n]+/g, " ").trim();

    // se str2 não vier nada, retorna só str1 (cortado no limite)
    if (!str2) {
      return str1.slice(0, maxLen);
    }

    // monta a string concatenada com " - "
    let result = `${str1} - ${str2}`;

    // aplica limite de 120 caracteres
    if (result.length > maxLen) {
      result = result.slice(0, maxLen);
    }

    return result;
  }

  function gerarIdUnico(cnpj) {
    return `${cnpj}-${Date.now().toString(36)}-${Math.random().toString(36).substr(2, 5)}`;
  }

  async function validarNota(venda, modelo, tentativa = 1) {
    // Configuração única dos headers
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };

    try {
      // 1) Buscar histórico
      const historico = await axios.get(
        `${api.technfe}/v1/historico/sessao/${venda.InfoSistema.sessao}`,
        options
      );
      console.log(`Tentativa ${tentativa}:`, historico.data);

      if (historico.data.length > 0) {
        const doc = historico.data[0];

        // 2) Verifica se autorizou (100)
        if (doc?.sitCodigo === 100) {
          console.log('antes de compartilhar o pdf');
          await sharingPdf(doc.docChaAcesso, modelo);

          // Preenche dados do documento na venda
          venda.InfoSistema.chaveDocFiscal = doc.docChaAcesso;
          venda.InfoSistema.numeroDocFiscal = String(doc.docNumero);
          venda.InfoSistema.serieDocFiscal = String(doc.docSerie);
          venda.InfoSistema.docDhAut = doc.docDhAut;

          await gravarLog(venda);

          // 3) Envia WhatsApp se tiver telefone
          if (telefoneEnvio) {
            const respEnvio = await axios.get(
              `${api.techfood}/v1/envioWhatsapp/enviar/${doc.docChaAcesso}/${config.restaurante.id}/${telefoneEnvio}`,
              options
            );
            console.log(respEnvio.data);
          }

          // 4) Cria evento no backend
          const response2 = await criarEvento(venda);
          console.log(response2);

          if (response2?.data) {
            // 5) Finaliza Techsapp
            if (tokenPedidoTechsapp) {
              const optionsTechsapp = {
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Basic ${config.restaurante.basic_token}`,
                },
              };
              const bodyConfirmacao = {
                chave_cupom: config.restaurante.basic_token,
                numero_cupom: config.restaurante.dominio,
              };

              await axios.post(
                `https://www.${config.restaurante.dominio}.com.br/backend/api/pdv/pedido/finalizarPedido/${tokenPedidoTechsapp}`,
                bodyConfirmacao,
                optionsTechsapp
              );
            }

            // 6) Limpa estado
            setTokenPedidoTechsapp(null);
            setProcessamentoMsg('');
            setLoading(false);
            closeModal();
            setProdutos([]);
            setConsumidor(null);
            setNomeCupom('');
            setDocumentoCupom('');
            setConsumidorIdentificado(false);
          }
        } else {
          window.alert('Ocorreu algum problema na geração da nota.');
        }
      } else {
        // Se não encontrou nada e ainda não atingiu o limite de 3 tentativas
        if (tentativa < 3) {
          console.log(`⚠️ Nota não encontrada, tentando novamente em 5s... (tentativa ${tentativa + 1})`);
          setProcessamentoMsg(`⚠️ Nota não encontrada, tentando novamente em 5s... (tentativa ${tentativa + 1})`);
          setTimeout(() => validarNota(venda, modelo, tentativa + 1), 5000);
        } else {
          window.alert('Não foi possível recuperar a nota após 3 tentativas.');
        }
      }
    } catch (error) {
      console.error('Erro ao verificar/fechar venda:', error);
      window.alert('Não foi possível recuperar a nota.');
    } finally {
      setLoading(false);
    }
  }

  const emitirCupom = async () => {
    setLoading(true);



    setProcessamentoMsg('Emitindo Cupom Fiscal NFCE...');
    console.log(pagItem);

    console.log('emitirCupom');


    const detItemArray = Array();
    let vBC_ttlnfe = 0;
    let vICMS_ttlnfe = 0;
    let vFrete_ttlnfe = 0;
    let vDesc_ttlnfe = 0;
    let vOutro_ttlnfe = 0;
    let vProd_ttlnfe = 0;
    let qBCMonoRet_ttlnfe = 0;
    let vICMSMonoRet_ttlnfe = 0;
    let vIBSUF_ttnfe = 0;
    let vIBSMun_ttnfe = 0;
    let vCBS_ttnfe = 0;
    let vICMSDeson_ttlnfe = 0;

    produtos.map(produto => {
      // Fake enquanto não vem do produto
      produto.indTot = '1';
      //produto.frete = 0;
      // Somar frete de todos os produtos
      console.log(vFrete_ttlnfe);
      console.log(produto.frete);
      vFrete_ttlnfe += produto.frete ? parseFloat(produto.frete) : 0;
      vDesc_ttlnfe += parseFloat(produto.valorDesconto);
      vOutro_ttlnfe += parseFloat(produto.valorAcrescimo);

      if (produto.indTot === '1') {
        vProd_ttlnfe += produto.quantidade * produto.preco;
      }

      let icms = {
        orig: `${produto.origem}`,
        CST: `${produto.cst}`,
        vBC: '0',
      };
      // helpers (pode deixar fora se quiser, mas dá pra manter aqui dentro também)
      const toNum = (v) => {
        if (v === null || v === undefined || v === '') return 0;
        // aceita "1.234,56", "1234,56", "1234.56"
        const s = String(v).trim().replace(/\s/g, '');
        const norm =
          s.includes(',') && s.includes('.')
            ? s.replace(/\./g, '').replace(',', '.')
            : s.includes(',') && !s.includes('.')
              ? s.replace(',', '.')
              : s;
        const n = Number(norm);
        return Number.isFinite(n) ? n : 0;
      };

      const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

      const cst = String(produto.cst);

      if (
        cst === '00' ||
        cst === '10' ||
        cst === '20' ||
        cst === '30' ||
        cst === '70' ||
        cst === '90' ||
        cst === '900'
      ) {
        // 0 - Margem Valor Agregado (%);
        // 1 - Pauta (Valor);
        // 2 - Preço Tabelado Máx. (valor);
        // 3 - Valor da operação.
        const toNum = (v) => {
          if (v === null || v === undefined || v === '') return 0;
          const s = String(v).trim().replace(/\s/g, '');
          const norm =
            s.includes(',') && s.includes('.')
              ? s.replace(/\./g, '').replace(',', '.')
              : s.includes(',') && !s.includes('.')
                ? s.replace(',', '.')
                : s;
          const n = Number(norm);
          return Number.isFinite(n) ? n : 0;
        };

        const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

        const cst = String(produto.cst);

        // ✅ agora pega o campo certo
        const pRedBC_raw =
          produto.pRedBC ??
          produto.predBc ??     // <- AQUI
          produto.predbc ??
          produto.pRedBc ??
          0;

        const pRedBC = toNum(pRedBC_raw);

        console.log("🧪 pRedBC bruto:", pRedBC_raw, "| normalizado:", pRedBC);

        // base original
        const quantidade = toNum(produto.quantidade);
        const preco = toNum(produto.preco);
        const valorAcrescimo = toNum(produto.valorAcrescimo);
        const valorDesconto = toNum(produto.valorDesconto);

        const vBC_original = quantidade * preco + valorAcrescimo - valorDesconto;

        let vBC_final = round2(vBC_original);

        // ✅ aplica redução sempre que pRedBC > 0
        if (pRedBC > 0 && pRedBC <= 100) {
          icms.pRedBC = round2(pRedBC);
          vBC_final = round2(vBC_original * (1 - pRedBC / 100));
          console.log("✅ Redução aplicada. vBC original:", vBC_original, "vBC reduzida:", vBC_final);
        } else {
          delete icms.pRedBC;
          console.log("❌ Sem redução aplicada");
        }

        icms.vBC = round2(vBC_final);

        // calcula ICMS (se o seu CST calcula)
        icms.modBC = '3';
        const aliquotaICMS = toNum(produto.picms);
        icms.pICMS = round2(aliquotaICMS);
        icms.vICMS = round2((icms.pICMS / 100) * icms.vBC);

        vBC_ttlnfe += icms.vBC;
        vICMS_ttlnfe += icms.vICMS;

        // ✅ motDesICMS quando CST for 20/30/40/70/90
        const cstComMotDes = new Set(['20', '30', '40', '70', '90', '900']);
        if (cstComMotDes.has(cst)) {
          const icmsSemReducao = round2((icms.pICMS / 100) * vBC_original);
          const icmsComReducao = round2((icms.pICMS / 100) * vBC_final);
          const vICMSDeson = round2(icmsSemReducao - icmsComReducao);

          console.log("🧾 vICMSDeson calc:", vICMSDeson);

          if (vICMSDeson > 0) {
            icms.vICMSDeson = vICMSDeson;
            icms.motDesICMS = produto.motDesICMS ?? '9'; // no seu JSON vem "3"
            console.log("🎯 motDesICMS aplicado:", icms.motDesICMS);
            vICMSDeson_ttlnfe += vICMSDeson; // ✅ soma

          } else {
            delete icms.vICMSDeson;
            delete icms.motDesICMS;
          }
        }
      }

      if (
        produto.cst == '61' && produto.cfop == '5656'
      ) {
        // caso falte qualquer variavel parar a operação e avisar
        // validar o peso
        const qBCMonoRet = (produto.weight || 1) * produto.quantidade;

        icms.qBCMonoRet = qBCMonoRet;
        qBCMonoRet_ttlnfe += qBCMonoRet;

        icms.adRemICMSRet = produto.adRemIcmsRet;

        icms.vICMSMonoRetSemArredondar = qBCMonoRet * (produto.adRemIcmsRet / 100);

        const valor = qBCMonoRet * (produto.adRemIcmsRet / 100);

        icms.vICMSMonoRet = Math.round((valor - Number.EPSILON) * 100) / 100;

        vICMSMonoRet_ttlnfe += Math.round((valor - Number.EPSILON) * 100) / 100;

      }





      const pis = buildPIS(produto, icms?.vBC);
      const cofins = buildCOFINS(produto, icms?.vBC);
      const IBSCBS = buildIBSCBS(produto, icms?.vBC, vIBSUF_ttnfe, vIBSMun_ttnfe, vCBS_ttnfe);
      console.log(produto);


      let item = {
        infADProd: sanitizeInfAdProd(produto?.observacao),
        prod: {
          cProd: `${produto.id}`,
          cEAN: `${produto.ean}`,
          xProd:
            config.tpAmb === '2'
              ? 'NOTA FISCAL EMITIDA EM AMBIENTE DE HOMOLOGACAO - SEM VALOR FISCAL'
              : trataXProd(produto.nome, produto.observacao),
          NCM: `${produto.ncm}`,
          CFOP: `${produto.cfop}`,
          uCOM: `${produto.unidade}`,
          qCOM: `${produto.quantidade}`,
          vUnCom: `${produto.preco}`,
          vProd: `${produto.quantidade * produto.preco}`,
          cEANTrib: `${produto.ean ? produto.ean : 'SEM GTIN'}`,
          uTrib: `${produto.unidadeTributavel || produto.unidade}`, // Aqui ira vir do cadastro ou repete a produto.unidade caso esteja sem nada
          qTrib: `${produto.quantidade}`,
          vUnTrib: `${produto.preco}`,
          indTot: `${produto.indTot}`,
          nTipoItem: `${produto.ntipoItem}`,
          vFrete: `${produto.frete ? produto.frete : '0'}`,
          vDesc: `${parseFloat(produto.valorDesconto).toFixed(2)}`,
          CEST: `${produto.cest}`,
          vOutro_item: `${parseFloat(produto.valorAcrescimo).toFixed(2)}`,
          idVendedor: `${produto.idVendedor || ''}`,
        },
        imposto: {
          ICMS: icms,
          PIS: pis,
          COFINS: cofins,
          IBSCBS: IBSCBS,
          vTotTrib: '0',
        },
      };

      if (produto.xPed_item && produto.nItemPed) {
        item.prod.xPed_item = produto.xPed_item;
        item.prod.nItemPed = produto.nItemPed
      }

      if (produto.ntipoItem == '4') {
        console.log(produto);

        if (produto.cprodAnp == '210203001') {
          item.prod.qTrib = (produto.weight || 1) * produto.quantidade;
          item.prod.vUnTrib = produto.preco / (produto.weight || 1);
          // Essa atribuição vai sair ela vira direto do cadastro
          //item.prod.uTrib = 'KG';
        }

        item.prod.comb = {
          cProdANP: produto.cprodAnp || '',
          descANP: produto.descAnp || '',
          pGLP: produto.pglp,
          vPart: produto.vpart,
          UFcons: produto.ufConst || ''
        }
      }

      if (produto.cbenef) {
        item.prod.cBenef = produto.cbenef;
      }


      detItemArray.push(item);
    });
    console.log(vDesc_ttlnfe);

    let nomeDoConsumidor = '';
    if (consumidor?.nomeCompleto) {
      nomeDoConsumidor = consumidor?.nomeCompleto;
    } else {

      if (nomeCupom) {
        nomeDoConsumidor = nomeCupom;
      }
    }

    var venda = {
      ModeloDocumento: 'NFCe',
      Versao: '4.0',
      ide: {
        cNF: '00000987',
        cUF: config.restaurante.endereco.cidade.cuf,
        natOp: 'Venda',
        indPag: indPag,
        mod: '65',
        serie: config?.serie,
        nNF: '',
        dhEmi: '',
        fusoHorario: '-03:00',
        tpNf: '1',
        idDest: '1',
        indFinal: '1',
        indPres: '1',
        cMunFg: config.restaurante.endereco.cidade.ibge,
        tpImp: '4',
        tpEmis: '1',
        tpAmb: config.tpAmb,
        finNFe: '1',
        procEmi: '0',
      },
      emit: {
        CNPJ_emit: config.restaurante.cnpj,
        xNome: config.restaurante.nome,
        IE: config.restaurante.ie,
        CRT: config.restaurante.crt,
        enderEmit: {
          xLgr: config.restaurante.endereco.logradouro,
          nro: config.restaurante.endereco.numero,
          xBairro: config.restaurante.endereco.bairro,
          cMun: config.restaurante.endereco.cidade.ibge,
          xMun: config.restaurante.endereco.cidade.nome,
          UF: config.restaurante.endereco.cidade.estado,
          CEP: config.restaurante.endereco.cep,
        },
      },
      dest: {
        CPF_dest:
          config.tpAmb === '2' ? '39247350859' : documentoCupom ? documentoCupom : consumidor?.documentoCpfCnpj ? consumidor?.documentoCpfCnpj : '',
        indIEDest: documentoCupom || consumidor?.documentoCpfCnpj ? '9' : '0',
        xNome_dest:
          config.tpAmb === '2'
            ? 'NF-E EMITIDA EM AMBIENTE DE HOMOLOGACAO - SEM VALOR FISCAL'
            : documentoCupom
              ? nomeCupom
                ? nomeCupom
                : 'Consumidor Identificado'
              : '',
        enderDest: {
          nro_dest: consumidor?.endereco?.numero || null,
          xBairro_dest: consumidor?.endereco?.bairro || null,
          xEmail_dest: emailNota ? emailNota : consumidor?.email || null,
          //xEmail_dest: 'pablo@tech-union.com.br',
          xLgr_dest: consumidor?.endereco?.logradouro || null,
          cMun_dest: consumidor?.endereco?.cidade?.ibge || null,
          xMun_dest: consumidor?.endereco?.cidade?.nome || null,
          UF_dest: consumidor?.endereco?.ufEstado || consumidor?.endereco?.cidade?.estado || null,
          CEP_dest: consumidor?.endereco?.cep || null,
        },
      },

      det: {
        detItem: detItemArray,
      },
      total: {
        ICMStot: {
          //Informar o somatório do campo vBC de item produto com CST = 00, 10, 20, 30, 70 e 90.
          // Com CSOSN = 900. NT2011.004
          vBC_ttlnfe: vBC_ttlnfe.toFixed(2),
          vICMS_ttlnfe: vICMS_ttlnfe.toFixed(2),
          vICMSDeson_ttlnfe: vICMSDeson_ttlnfe.toFixed(2) || '0.00',
          vBCST_ttlnfe: '0.00',
          vST_ttlnfe: '0.00',
          vProd_ttlnfe: vProd_ttlnfe.toFixed(2),
          vFrete_ttlnfe: vFrete_ttlnfe.toFixed(2),
          vSeg_ttlnfe: '0.00',
          vDesc_ttlnfe: vDesc_ttlnfe.toFixed(2),
          vIPI_ttlnfe: '0.00',
          vPIS_ttlnfe: '0.00',
          vCOFINS_ttlnfe: '0.00',
          vOutro: vOutro_ttlnfe.toFixed(2),
          qBCMonoRet_ttlnfe: qBCMonoRet_ttlnfe.toFixed(2),
          vICMSMonoRet_ttlnfe: vICMSMonoRet_ttlnfe.toFixed(2),
          vNF: (
            // vBC_ttlnfe +
            // vICMS_ttlnfe +
            vProd_ttlnfe +
            vFrete_ttlnfe -
            vDesc_ttlnfe +
            vOutro_ttlnfe
          ).toFixed(2),
          vTotTrib_ttlnfe: '0.00',
        },
        IBSCBSTot: {
          vBCIBSCBS: vBC_ttlnfe.toFixed(2),
          gIBS: {
            gIBSUF: {
              vDif: "0.00",
              vDevTrib: "0.00",
              vIBSUF: vIBSUF_ttnfe.toFixed(2)
            },
            gIBSMun: {
              vDif: "0.00",
              vDevTrib: "0.00",
              vIBSMun: vIBSMun_ttnfe.toFixed(2)
            },
            vIBS: "0.00",
            vCredPres: "0.00",
            vCredPresCondSus: "0.00"
          },
          gCBS: {
            vDif: "0.00",
            vDevTrib: "0.00",
            vCBS: vCBS_ttnfe.toFixed(2),
            vCredPres: "0.00",
            vCredPresCondSus: "0.00"
          }
        }

      },
      transp: parametros?.transp || {
        modFrete: '9',
      },
      pag: {
        pagItem: pagItem,
      },
      InfoSistema: {
        chaveDocFiscal: '',
        numeroDocFiscal: '',
        serieDocFiscal: '',
      },
    };

    console.log(parametros);
    if (parametros?.NumeroPedido) {
      venda.ide.NumeroPedido = parametros.NumeroPedido;
    }
    const telefoneFinal = consumidor?.telefone || telefoneEnvio;

    if (telefoneFinal) {
      const telefoneLimpo = telefoneFinal.replace(/\D/g, '');
      const telefoneSem55 = telefoneLimpo.replace(/^55/, '');
      if (telefoneSem55) {
        venda.dest.enderDest.fone_dest = telefoneSem55;
      }

    }



    if (config?.terminalComercial?.gerenciaEstoque == true && config?.terminalComercial?.venderZerado == false) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      try {
        const validarProdutos = await axios.post(
          `${api.techspdv}/v1/restaurantes/${config.restaurante.id}/produtos/validarEstoque`,
          detItemArray,
          options
        );
        console.log(validarProdutos);
      } catch (error) {


        // Verifica se a resposta tem um status 400 e trata adequadamente
        if (error.response?.status === 400) {
          console.error(error.response.data || "Erro ao validar produtos!");
          message.error(error.response.data || "Erro ao validar produtos!");
          setLoading(false);
          return;
        } else {
          console.error("Falha na comunicação com o servidor!");
          message.error("Falha na comunicação com o servidor!");
          setLoading(false);
          return;
        }
      }
    }

    console.log('após o if');
    // await gravarLog(venda);
    //    return;
    venda.InfoSistema.sessao = gerarIdUnico(config.restaurante.cnpj);
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };
    setProcessamentoMsg('Aguardando Resposta do SEFAZ..');
    const response = await axios
      .post(
        `${api.technfe}/v1/nota/gerarNota2`,
        venda,
        options,
      )
      .catch(error => {
        // Tratar erros aqui
        if (error.response) {
          console.log('Status de erro:', error.response.status);
          console.log('Dados de erro:', error.response.data);
          const userResponse = window.confirm(
            error.response?.data?.detail ? error.response.data.detail : error.response?.data?.error ? error.response?.data?.error : 'Falha na geração da nota. Deseja continuar a venda?'
          );

          if (!userResponse) {
            // Usuário clicou em "Não"
            setLoading(false);
            setProcessamentoMsg('');
            closeModal();
            setProdutos([]);
            setMensagemTela('');
            setConsumidor(null);
            setNomeCupom('');
            setDocumentoCupom('');
            setConsumidorIdentificado(false);
            setAcresDescFrete({
              acresTotal: '0',
              descTotal: '0',
              frete: '0',
            });
          } else {
            // Usuário clicou em "Sim"
            console.log('Continuar');
          }
          setLoading(false);
          setProcessamentoMsg('');
          setMensagemTela('');
          return;
        } else if (error.request) {
          // A solicitação foi feita, mas não recebeu resposta
          console.error('Não recebeu resposta');
        } else {
          // Ocorreu um erro ao configurar a solicitação
          console.error('Erro ao configurar a solicitação:', error.message);
        }
      });

    if (response?.data.documento.sitCodigo === 100) {
      await sharingPdf(response.data.documento.docChaAcesso, 'NFCE');

      venda.InfoSistema.chaveDocFiscal = response.data.documento.docChaAcesso;
      venda.InfoSistema.numeroDocFiscal =
        response.data.documento.docNumero.toString();
      venda.InfoSistema.serieDocFiscal =
        response.data.documento.docSerie.toString();
      venda.InfoSistema.docDhAut = response.data.documento.docDhAut;
      venda.InfoSistema.idVendedorOrcamento = idVendedorOrcamento || '';
      venda.InfoSistema.idOrcamento = idOrcamento || '';



      await gravarLog(venda);

      // console.log('Acessadno a segunda api com o json');
      console.log(venda);
      if (telefoneEnvio) {
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + accessToken,
          },
        };

        const respEnvio = await axios.get(
          `${api.techfood}/v1/envioWhatsapp/enviar/${response.data.documento.docChaAcesso}/${config.restaurante.id}/${telefoneEnvio}`,
          options
        );
        console.log(respEnvio.data);
      }

      const response2 = await criarEvento(venda);
      console.log(response2);
      if (response2.data) {

        const atualizarProdutosVenda = config?.terminalComercial?.atualizarProdutoNaVenda;
        console.log(atualizarProdutosVenda);
        if (atualizarProdutosVenda) {

          for (const produto of produtos) {

            await axiosInstance.get(
              `${api.techfood}/v1/restaurantes/${config?.idLoja}/produtos/atualizarPreco/${produto?.id}/${Number(produto?.preco ?? 0).toFixed(2)}`,
              options
            );

          }

        }

        if (tokenPedidoTechsapp) {
          setProcessamentoMsg('Validando Documentos Fiscais na Plataforma de Pedidos...');

          const options = {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: `Basic ${config.restaurante.basic_token}`,
            },
          };
          const bodyConfirmacao = {
            chave_cupom: config.restaurante.basic_token,
            numero_cupom: config.restaurante.dominio
          }

          await axios.post(
            `https://www.${config.restaurante.dominio}.com.br/backend/api/pdv/pedido/finalizarPedido/${tokenPedidoTechsapp}`, bodyConfirmacao,
            options
          );

        }
        console.log('response2.data');
        console.log(response2.data);
        console.log(venda.pag.pagItem);
        console.log(venda.det.detItem);
        console.log(venda.det.detItem.imposto);
        console.log(response2.status);
        setTokenPedidoTechsapp(null);
        setProcessamentoMsg('');
        setMensagemTela('');
        setVendaPuxada(false);
        setLoading(false);
        closeModal();
        setProdutos([]);
        setConsumidor(null);
        setNomeCupom('');
        setDocumentoCupom('');
        setConsumidorIdentificado(false);
        setAcresDescFrete({
          acresTotal: '0',
          descTotal: '0',
          frete: '0',
        });
        focarCodigoDeBarras();
      }
    } else {
      if (error.code === 'ECONNABORTED') {
        console.warn('Timeout atingido, agendando validação...');
        console.log('Falha na geração da nota não foi possivel determinar o problema!');
        // window.alert('Falha na geração da nota: não foi possivel determinar o problema, aguarde tentativa de recuperação.');
        setProcessamentoMsg('Falha na geração da nota: não foi possivel determinar o problema, tentando recuperar a nota.');
        console.log(response);
        setTimeout(() => validarNota(venda, 'NFCE'), 5000);
      }
      // Status 503
      else if (error.response && error.response.status === 503) {
        console.warn('Servidor retornou 503, agendando validação...');
        setTimeout(() => validarNota(venda, 'NFCE'), 5000);
      }
      else {
        console.error('Erro inesperado:', error);
      }
    }

  };

  const trocarCfop = (cfop, cfopInterestadual) => {
    const novoCfop = cfopInterestadual.find(p => p.interno === cfop);
    return novoCfop?.externo || cfop;
  };

  function identificarCpfCnpj(valor) {

    if (!valor) return null;

    // remove tudo que não é número
    const str = valor.replace(/\D/g, "");
    console.log(str.length === 14);
    if (str.length === 11) {
      return "CPF";
    } else if (str.length === 14) {
      return "CNPJ";
    } else {
      return "Inválido";
    }
  }


  const emitirCupomNFE = async () => {
    setLoading(true);

    setProcessamentoMsg('Emitindo DANFE e Nota Fiscal NFE..');
    console.log(loja);
    console.log(config.restaurante.endereco.cidade.estado);
    console.log(consumidor?.endereco?.ufEstado);


    let vendaInterestadual = false;

    if (consumidor?.endereco?.ufEstado) {
      vendaInterestadual = consumidor?.endereco?.ufEstado != config.restaurante.endereco.cidade.estado;
    } else {
      vendaInterestadual = consumidor?.endereco?.cidade?.estado != config.restaurante.endereco.cidade.estado;
    }




    console.log(vendaInterestadual);
    console.log(pagItem);
    let icmsInterestadual = {};
    let cfopInterestadual = [];
    if (vendaInterestadual) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      try {
        icmsInterestadual = await axios.get(
          `${api.techfood}/v1/icms-interestadual/${config.restaurante.endereco.cidade.estado}/${consumidor?.endereco?.ufEstado || consumidor?.endereco?.cidade?.estado}`,
          options,
        )
        console.log(icmsInterestadual.data);
      } catch (error) {

      }


      try {
        cfopInterestadual = await axios.get(
          `${api.techfood}/v1/cfop-interestadual`,
          options,
        );
        console.log(cfopInterestadual.data);
      } catch (error) {
        console.error("Erro ao buscar CFOP:", error);
      }
    }

    console.log('emitirCupom');

    const detItemArray = Array();
    let vBC_ttlnfe = 0;
    let vICMS_ttlnfe = 0;
    let vFrete_ttlnfe = 0;
    let vDesc_ttlnfe = 0;
    let vOutro_ttlnfe = 0;
    let vProd_ttlnfe = 0;
    let qBCMonoRet_ttlnfe = 0;
    let vICMSMonoRet_ttlnfe = 0;
    let vIBSUF_ttnfe = 0;
    let vIBSMun_ttnfe = 0;
    let vCBS_ttnfe = 0;
    let vICMSDeson_ttlnfe = 0;

    for (const produto of produtos) {
      console.log(vendaInterestadual);
      if (vendaInterestadual) {
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + accessToken,
          },
        };


      }

      // Fake enquanto não vem do produto
      produto.indTot = '1';
      //produto.frete = 0;
      // Somar frete de todos os produtos
      console.log(vFrete_ttlnfe);
      console.log(produto.frete);
      vFrete_ttlnfe += produto.frete ? parseFloat(produto.frete) : 0;
      vDesc_ttlnfe += parseFloat(produto.valorDesconto);
      vOutro_ttlnfe += parseFloat(produto.valorAcrescimo);

      if (produto.indTot === '1') {
        vProd_ttlnfe += produto.quantidade * produto.preco;
      }

      let icms = {
        orig: `${produto.origem}`,
        CST: `${produto.cst}`,
        vBC: '0',
      };
      const toNum = (v) => {
        if (v === null || v === undefined || v === '') return 0;
        // aceita "1.234,56", "1234,56", "1234.56"
        const s = String(v).trim().replace(/\s/g, '');
        const norm =
          s.includes(',') && s.includes('.')
            ? s.replace(/\./g, '').replace(',', '.')
            : s.includes(',') && !s.includes('.')
              ? s.replace(',', '.')
              : s;
        const n = Number(norm);
        return Number.isFinite(n) ? n : 0;
      };

      const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

      const cst = String(produto.cst);

      if (
        cst === '00' ||
        cst === '10' ||
        cst === '20' ||
        cst === '30' ||
        cst === '70' ||
        cst === '90' ||
        cst === '900'
      ) {
        // 0 - Margem Valor Agregado (%);
        // 1 - Pauta (Valor);
        // 2 - Preço Tabelado Máx. (valor);
        // 3 - Valor da operação.
        const toNum = (v) => {
          if (v === null || v === undefined || v === '') return 0;
          const s = String(v).trim().replace(/\s/g, '');
          const norm =
            s.includes(',') && s.includes('.')
              ? s.replace(/\./g, '').replace(',', '.')
              : s.includes(',') && !s.includes('.')
                ? s.replace(',', '.')
                : s;
          const n = Number(norm);
          return Number.isFinite(n) ? n : 0;
        };

        const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

        const cst = String(produto.cst);

        // ✅ agora pega o campo certo
        const pRedBC_raw =
          produto.pRedBC ??
          produto.predBc ??     // <- AQUI
          produto.predbc ??
          produto.pRedBc ??
          0;

        const pRedBC = toNum(pRedBC_raw);

        console.log("🧪 pRedBC bruto:", pRedBC_raw, "| normalizado:", pRedBC);

        // base original
        const quantidade = toNum(produto.quantidade);
        const preco = toNum(produto.preco);
        const valorAcrescimo = toNum(produto.valorAcrescimo);
        const valorDesconto = toNum(produto.valorDesconto);

        const vBC_original = quantidade * preco + valorAcrescimo - valorDesconto;

        let vBC_final = round2(vBC_original);

        // ✅ aplica redução sempre que pRedBC > 0
        if (pRedBC > 0 && pRedBC <= 100) {
          icms.pRedBC = round2(pRedBC);
          vBC_final = round2(vBC_original * (1 - pRedBC / 100));
          console.log("✅ Redução aplicada. vBC original:", vBC_original, "vBC reduzida:", vBC_final);
        } else {
          delete icms.pRedBC;
          console.log("❌ Sem redução aplicada");
        }

        icms.vBC = round2(vBC_final);

        // calcula ICMS (se o seu CST calcula)
        icms.modBC = '3';
        const aliquotaICMS = toNum(produto.picms);
        icms.pICMS = round2(aliquotaICMS);
        icms.vICMS = round2((icms.pICMS / 100) * icms.vBC);

        vBC_ttlnfe += icms.vBC;
        vICMS_ttlnfe += icms.vICMS;

        // ✅ motDesICMS quando CST for 20/30/40/70/90
        const cstComMotDes = new Set(['20', '30', '40', '70', '90', '900']);
        if (cstComMotDes.has(cst)) {
          const icmsSemReducao = round2((icms.pICMS / 100) * vBC_original);
          const icmsComReducao = round2((icms.pICMS / 100) * vBC_final);
          const vICMSDeson = round2(icmsSemReducao - icmsComReducao);

          console.log("🧾 vICMSDeson calc:", vICMSDeson);

          if (vICMSDeson > 0) {
            icms.vICMSDeson = vICMSDeson;
            icms.motDesICMS = produto.motDesICMS ?? '9'; // no seu JSON vem "3"
            console.log("🎯 motDesICMS aplicado:", icms.motDesICMS);
            vICMSDeson_ttlnfe += vICMSDeson; // ✅ soma

          } else {
            delete icms.vICMSDeson;
            delete icms.motDesICMS;
          }
        }
      }

      if (
        produto.cst == '61' && produto.cfop == '5656'
      ) {
        // caso falte qualquer variavel parar a operação e avisar
        const qBCMonoRet = produto.weight * produto.quantidade;

        icms.qBCMonoRet = qBCMonoRet;
        qBCMonoRet_ttlnfe += qBCMonoRet;



        icms.adRemICMSRet = produto.adRemIcmsRet;

        icms.vICMSMonoRetSemArredondar = qBCMonoRet * (produto.adRemIcmsRet / 100);

        const valor = qBCMonoRet * (produto.adRemIcmsRet / 100);

        icms.vICMSMonoRet = Math.round((valor - Number.EPSILON) * 100) / 100;

        vICMSMonoRet_ttlnfe += Math.round((valor - Number.EPSILON) * 100) / 100;

      }
      const pis = buildPIS(produto, icms?.vBC);
      const cofins = buildCOFINS(produto, icms?.vBC);
      const IBSCBS = buildIBSCBS(produto, icms?.vBC, vIBSUF_ttnfe, vIBSMun_ttnfe, vCBS_ttnfe);

      let item = {
        infADProd: sanitizeInfAdProd(produto?.observacao),
        prod: {
          cProd: `${produto.id}`,
          cEAN: `${produto.ean}`,
          xProd:
            config.tpAmb === '2'
              ? 'NOTA FISCAL EMITIDA EM AMBIENTE DE HOMOLOGACAO - SEM VALOR FISCAL'
              : `${produto.nome}`,
          NCM: `${produto.ncm}`,
          CFOP: vendaInterestadual ? trocarCfop(produto.cfop, cfopInterestadual.data) : `${produto.cfop}`,
          uCOM: `${produto.unidade}`,
          qCOM: `${produto.quantidade}`,
          vUnCom: `${produto.preco}`,
          vProd: `${produto.quantidade * produto.preco}`,
          cEANTrib: `${produto.ean ? produto.ean : 'SEM GTIN'}`,
          uTrib: `${produto.unidadeTributavel || produto.unidade}`,
          qTrib: `${produto.quantidade}`,
          vUnTrib: `${produto.preco}`,
          indTot: `${produto.indTot}`,
          nTipoItem: `${produto.ntipoItem}`,
          vFrete: `${produto.frete ? produto.frete : '0'}`,
          vDesc: `${parseFloat(produto.valorDesconto).toFixed(2)}`,
          CEST: `${produto.cest}`,
          vOutro_item: `${parseFloat(produto.valorAcrescimo).toFixed(2)}`,
          idVendedor: `${produto.idVendedor || ''}`
        },
        imposto: {
          ICMS: icms,
          PIS: pis,
          COFINS: cofins,
          IBSCBS: IBSCBS,
          vTotTrib: '0',
        },
      };
      if (produto.xPed_item && produto.nItemPed) {
        item.prod.xPed_item = produto.xPed_item;
        item.prod.nItemPed = produto.nItemPed
      }
      if (produto.ntipoItem == '4') {
        console.log(produto);

        if (produto.cprodAnp == '210203001') {
          item.prod.qTrib = produto.weight * produto.quantidade;
          item.prod.vUnTrib = produto.preco / produto.weight;
          //item.prod.uTrib = 'KG';
        }
        item.prod.comb = {
          cProdANP: produto.cprodAnp || '',
          descANP: produto.descAnp || '',
          pGLP: produto.pglp,
          vPart: produto.vpart,
          UFcons: produto.ufConst || ''
        }
      }
      if (produto.cbenef) {
        item.prod.cBenef = produto.cbenef;
      }
      detItemArray.push(item);
    };
    console.log(vDesc_ttlnfe);
    let nomeDoConsumidor = '';

    if (consumidor?.nomeCompleto) {
      nomeDoConsumidor = consumidor?.nomeCompleto;
    } else {

      if (nomeCupom) {
        nomeDoConsumidor = nomeCupom;
      }
    }

    // 1 Empresa com IE  | 2 empresa sem IE | 9 pessoa fisica
    let indIEDestValidado = '0';
    console.log('indIEDestValidado');
    console.log(documentoCupom);
    console.log(consumidor?.documentoCpfCnpj);
    if (config.tpAmb === '2') {
      indIEDestValidado = '9';
    } else {
      if (identificarCpfCnpj(documentoCupom || consumidor?.documentoCpfCnpj) == 'CPF') {

        indIEDestValidado = '9';
      } else {
        if (identificarCpfCnpj(documentoCupom || consumidor?.documentoCpfCnpj) == 'CNPJ' && (consumidor?.ie || consumidor?.documentoRgIE)) {

          indIEDestValidado = '1';
        } else {
          console.log(identificarCpfCnpj(documentoCupom));
          if (identificarCpfCnpj(documentoCupom || consumidor?.documentoCpfCnpj) == 'CNPJ') {

            indIEDestValidado = '2';
          } else {
            indIEDestValidado = '0';
          }
        }
      }
    }

    console.log(indIEDestValidado);



    var venda = {
      ModeloDocumento: 'NFE',
      Versao: '4.0',
      ide: {
        cNF: '00000987',
        cUF: config.restaurante.endereco.cidade.cuf,
        natOp: 'Venda',
        indPag: indPag,
        mod: '55',
        serie: config?.serie,
        nNF: '',
        dhEmi: '',
        fusoHorario: '-03:00',
        tpNf: '1',
        idDest: vendaInterestadual ? '2' : '1', // se uf do cliente for diferente  da uf do emissor tem que ser 2
        indFinal: '1',
        indPres: '1',
        cMunFg: config.restaurante.endereco.cidade.ibge,
        tpImp: '1',
        tpEmis: '1',
        tpAmb: config.tpAmb,
        finNFe: '1',
        procEmi: '0',
      },
      emit: {
        CNPJ_emit: config.restaurante.cnpj,
        xNome: config.restaurante.nome,
        IE: config.restaurante.ie,
        CRT: config.restaurante.crt,
        enderEmit: {
          xLgr: config.restaurante.endereco.logradouro,
          nro: config.restaurante.endereco.numero,
          xBairro: config.restaurante.endereco.bairro,
          cMun: config.restaurante.endereco.cidade.ibge,
          xMun: config.restaurante.endereco.cidade.nome,
          UF: config.restaurante.endereco.cidade.estado,
          CEP: config.restaurante.endereco.cep,
        },
      },
      dest: {
        CPF_dest:
          config.tpAmb === '2' ? '39247350859' : documentoCupom ? documentoCupom : consumidor?.documentoCpfCnpj ? consumidor?.documentoCpfCnpj : '',
        indIEDest: indIEDestValidado,
        xNome_dest:
          config.tpAmb === '2'
            ? 'NF-E EMITIDA EM AMBIENTE DE HOMOLOGACAO - SEM VALOR FISCAL'
            : documentoCupom || consumidor?.documentoCpfCnpj
              ? nomeDoConsumidor ? nomeDoConsumidor :
                'Consumidor Identificado'
              : '',
        enderDest: {
          nro_dest: consumidor?.endereco?.numero || null,
          xBairro_dest: consumidor?.endereco?.bairro || null,
          xEmail_dest: emailNota ? emailNota : consumidor?.email || null,
          //xEmail_dest: 'pablo@tech-union.com.br',
          xLgr_dest: consumidor?.endereco?.logradouro || null,
          cMun_dest: consumidor?.endereco?.cidade?.ibge || null,
          xMun_dest: consumidor?.endereco?.cidade?.nome || null,
          UF_dest: consumidor?.endereco?.ufEstado || consumidor?.endereco?.cidade?.estado || null,
          CEP_dest: consumidor?.endereco?.cep || null,
        }
      },

      det: {
        detItem: detItemArray,
      },
      total: {
        ICMStot: {
          //Informar o somatório do campo vBC de item produto com CST = 00, 10, 20, 30, 70 e 90.
          // Com CSOSN = 900. NT2011.004
          vBC_ttlnfe: vBC_ttlnfe.toFixed(2),
          vICMS_ttlnfe: vICMS_ttlnfe.toFixed(2),
          vICMSDeson_ttlnfe: vICMSDeson_ttlnfe.toFixed(2) || '0.00',
          vBCST_ttlnfe: '0.00',
          vST_ttlnfe: '0.00',
          vProd_ttlnfe: vProd_ttlnfe.toFixed(2),
          vFrete_ttlnfe: vFrete_ttlnfe.toFixed(2),
          vSeg_ttlnfe: '0.00',
          vDesc_ttlnfe: vDesc_ttlnfe.toFixed(2),
          vIPI_ttlnfe: '0.00',
          vPIS_ttlnfe: '0.00',
          vCOFINS_ttlnfe: '0.00',
          vOutro: vOutro_ttlnfe.toFixed(2),
          qBCMonoRet_ttlnfe: qBCMonoRet_ttlnfe.toFixed(2),
          vICMSMonoRet_ttlnfe: vICMSMonoRet_ttlnfe.toFixed(2),
          /*
          "(+) vProd_ttlnfe 
          (-) vDesc_ttlnfe 
          (+) vST_ttlnfe 
          (+) vFrete_ttlnfe
          (+) vSeg_ttlnfe 
          (+) vOutro_ttlnfe 
          (+) vII_ttlnfe 
          (+) vIPI_ttlnfe 
          (+) vServ_ttlnfe (NT2011/005)
          (+) vPIS 
          (+) vCofins"
          */
          vNF: (
            //  vBC_ttlnfe +
            //  vICMS_ttlnfe +
            vProd_ttlnfe +
            vFrete_ttlnfe -
            vDesc_ttlnfe +
            vOutro_ttlnfe
          ).toFixed(2),
          vTotTrib_ttlnfe: '0.00',
        },

        IBSCBSTot: {
          vBCIBSCBS: vBC_ttlnfe.toFixed(2),
          gIBS: {
            gIBSUF: {
              vDif: "0.00",
              vDevTrib: "0.00",
              vIBSUF: vIBSUF_ttnfe.toFixed(2)
            },
            gIBSMun: {
              vDif: "0.00",
              vDevTrib: "0.00",
              vIBSMun: vIBSMun_ttnfe.toFixed(2)
            },
            vIBS: "0.00",
            vCredPres: "0.00",
            vCredPresCondSus: "0.00"
          },
          gCBS: {
            vDif: "0.00",
            vDevTrib: "0.00",
            vCBS: vCBS_ttnfe.toFixed(2),
            vCredPres: "0.00",
            vCredPresCondSus: "0.00"
          }
        }
      },
      transp: parametros?.transp || {
        modFrete: '9',
      },
      pag: {
        pagItem: pagItem,
      },
      /*  cobr:{
         fat:{nFat:'001',vOrig:'1.00', vDesc:'0.00', vLiq:'1.00'},
         dup:[{nDup:'001',dVenc:'2026-01-01',vDup:'0.50'},{nDup:'002',dVenc:'2026-02-01',vDup:'0.50'}]
       },*/
      InfoSistema: {
        chaveDocFiscal: '',
        numeroDocFiscal: '',
        serieDocFiscal: '',
      },
    };

    if (idPedidoMkt) {
      venda.identificador = idPedidoMkt;
    }

    if (parametros?.NumeroPedido) {
      venda.ide.NumeroPedido = parametros.NumeroPedido;
    }


    if (mostrarCobranca) {

      const fat = {
        vLiq: parametros?.cobr?.vLiq,
        vDesc: parametros?.cobr?.vDesc,
        vOrig: parametros?.cobr?.vOrig,
        nFat: parametros?.cobr?.nFat,
      }


      const cobr = {
        fat: fat,
      }

      venda.cobr = cobr;


      if (parametros?.cobr?.dup?.dup) {
        venda.cobr.dup = parametros?.cobr?.dup?.dup;
      }

    }


    if (venda.dest.indIEDest == '1') {
      venda.dest.IE_dest = consumidor?.ie || consumidor?.documentoRgIE || null;
    }
    if (parametros.infCpl) {
      venda.infAdic = {
        infCpl: parametros.infCpl
      }
    }

    const telefoneFinal = consumidor?.telefone || telefoneEnvio;

    if (telefoneFinal) {
      const telefoneLimpo = telefoneFinal.replace(/\D/g, '');
      const telefoneSem55 = telefoneLimpo.replace(/^55/, '');
      if (telefoneSem55) {
        venda.dest.enderDest.fone_dest = telefoneSem55;
      }

    }

    console.log(venda);

    console.log(consumidor);

    if (config?.terminalComercial?.gerenciaEstoque == true && config?.terminalComercial?.venderZerado == false) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      try {
        const validarProdutos = await axios.post(
          `${api.techspdv}/v1/restaurantes/${config.restaurante.id}/produtos/validarEstoque`,
          detItemArray,
          options
        );
        console.log(validarProdutos);
      } catch (error) {


        // Verifica se a resposta tem um status 400 e trata adequadamente
        if (error.response?.status === 400) {
          console.error(error.response.data || "Erro ao validar produtos!");
          message.error(error.response.data || "Erro ao validar produtos!");
          setLoading(false);
          return;
        } else {
          console.error("Falha na comunicação com o servidor!");
          message.error("Falha na comunicação com o servidor!");
          setLoading(false);
          return;
        }
      }
    }

    console.log('após o if');
    // await gravarLog(venda);
    //    return;
    venda.InfoSistema.sessao = gerarIdUnico(config.restaurante.cnpj);
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };

    setProcessamentoMsg('Aguardando Resposta do SEFAZ...');
    const response = await axios
      .post(
        `${api.technfe}/v1/nota/gerarNota2`,
        venda,
        options,
      )
      .catch(error => {
        // Tratar erros aqui
        if (error.response) {
          console.log('Status de erro:', error.response.status);
          console.log('Dados de erro:', error.response.data);
          const userResponse = window.confirm(

            error.response?.data?.detail ? error.response.data.detail : error.response?.data?.error ? error.response?.data?.error : 'Falha na geração da nota. Deseja continuar a venda?'

          );

          if (!userResponse) {
            // Usuário clicou em "Não"
            setLoading(false);
            closeModal();
            setProdutos([]);
            setConsumidor(null);
            setNomeCupom('');
            setDocumentoCupom('');
            setConsumidorIdentificado(false);
          } else {
            // Usuário clicou em "Sim"
            console.log('Continuar');
          }
          setLoading(false);
          return;
        } else if (error.request) {
          // A solicitação foi feita, mas não recebeu resposta
          console.error('Não recebeu resposta');
          setProcessamentoMsg('');
          setMensagemTela('');
        } else {
          // Ocorreu um erro ao configurar a solicitação
          console.error('Erro ao configurar a solicitação:', error.message);
          setProcessamentoMsg('');
          setMensagemTela('');
        }
      });


    if (response?.data.documento.sitCodigo === 100) {
      //if (false) {
      await sharingPdf(response.data.documento.docChaAcesso, 'NFE');
      downloadXmlViaIframe(response.data.documento.docXMLDownload);

      if (idPedidoMkt != "" && config.restaurante.tipoMkt == '3') {
        setProcessamentoMsg('Validando Documentos Fiscais na Plataforma de Pedidos...');
        const nota = await axiosInstance.get(
          `${api.technfe}/v1/historico/chave/${response.data.documento.docChaAcesso}`,
          options,
        )

        const respostaFaturamento = await axios.put(
          `https://apimarket.pedtech.com.br/v1/pedidos/faturar/${idPedidoMkt}/${config?.restaurante?.cnpj}`,
          {
            nfeDate: response.data.documento.docDhAut,
            nfeNumber: '' + response.data.documento.docNumero,
            nfeSerialNumber: '' + response.data.documento.docSerie,
            nfeAccessKey: response.data.documento.docChaAcesso,
            xml: nota.data._embedded.historico[0].xmlAutorizado || '',
          },
          { headers: { token: config?.tokenMarketplace } }
        );
        setIdPedidoMkt("");
      }


      if (idPedidoMkt != "" && config.restaurante.tipoMkt == '2') {
        setProcessamentoMsg('Validando Documentos Fiscais na Plataforma de Pedidos...');
        const nota = await axiosInstance.get(
          `${api.technfe}/v1/historico/chave/${response.data.documento.docChaAcesso}`,
          options,
        )

        const respostaFaturamento = await axios.put(
          `https://apimarket.pedtech.com.br/v1/oruc/pedidos/faturar/${idPedidoMkt}/${config?.restaurante?.cnpj}`,
          {
            nfeDate: response.data.documento.docDhAut,
            nfeNumber: '' + response.data.documento.docNumero,
            nfeSerialNumber: '' + response.data.documento.docSerie,
            nfeAccessKey: response.data.documento.docChaAcesso,
            xml: nota.data._embedded.historico[0].xmlAutorizado || '',
          },
          { headers: { token: config?.tokenMarketplace } }
        );
        setIdPedidoMkt("");
      }

      venda.InfoSistema.chaveDocFiscal = response.data.documento.docChaAcesso;
      venda.InfoSistema.numeroDocFiscal =
        response.data.documento.docNumero.toString();
      venda.InfoSistema.serieDocFiscal =
        response.data.documento.docSerie.toString();
      venda.InfoSistema.docDhAut = response.data.documento.docDhAut;
      venda.InfoSistema.idVendedorOrcamento = idVendedorOrcamento || '';
      venda.InfoSistema.idOrcamento = idOrcamento || '';

      await gravarLog(venda);

      // console.log('Acessadno a segunda api com o json');

      if (telefoneEnvio) {
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + accessToken,
          },
        };

        const respEnvio = await axios.get(
          `${api.techfood}/v1/envioWhatsapp/enviar/${response.data.documento.docChaAcesso}/${config.restaurante.id}/${telefoneEnvio}`,
          options
        );
        console.log(respEnvio.data);
      }

      const response2 = await criarEvento(venda);
      console.log(response2);
      if (response2.data) {

        const atualizarProdutosVenda = config?.terminalComercial?.atualizarProdutoNaVenda;
        console.log(atualizarProdutosVenda);
        if (atualizarProdutosVenda) {

          for (const produto of produtos) {

            await axiosInstance.get(
              `${api.techfood}/v1/restaurantes/${config?.idLoja}/produtos/atualizarPreco/${produto?.id}/${Number(produto?.preco ?? 0).toFixed(2)}`,
              options
            );

          }

        }

        if (tokenPedidoTechsapp) {
          setProcessamentoMsg('Validando Documentos Fiscais na Plataforma de Pedidos...');
          const options = {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: `Basic ${config.restaurante.basic_token}`,
            },
          };
          const bodyConfirmacao = {
            chave_cupom: config.restaurante.basic_token,
            numero_cupom: config.restaurante.dominio
          }

          await axios.post(
            `https://www.${config.restaurante.dominio}.com.br/backend/api/pdv/pedido/finalizarPedido/${tokenPedidoTechsapp}`, bodyConfirmacao,
            options
          );

        }

        console.log('response2.data');
        console.log(response2.data);
        console.log(venda.pag.pagItem);
        console.log(venda.det.detItem);
        console.log(venda.det.detItem.imposto);
        console.log(response2.status);
        setTokenPedidoTechsapp(null);
        setProcessamentoMsg('');
        setMensagemTela('');
        setVendaPuxada(false);
        setLoading(false);
        closeModal();
        setProdutos([]);
        setConsumidor(null);
        setNomeCupom('');
        setDocumentoCupom('');

        setConsumidorIdentificado(false);
      }
    } else {
      if (error.code === 'ECONNABORTED') {
        console.warn('Timeout atingido, agendando validação...');
        console.log('Falha na geração da nota não foi possivel determinar o problema!');
        // window.alert('Falha na geração da nota: não foi possivel determinar o problema, aguarde tentativa de recuperação.');
        setProcessamentoMsg('Falha na geração da nota: não foi possivel determinar o problema, tentando recuperar a nota.');
        console.log(response);
        setTimeout(() => validarNota(venda, 'NFE'), 5000);
      }
      // Status 503
      else if (error.response && error.response.status === 503) {
        console.warn('Servidor retornou 503, agendando validação...');
        setTimeout(() => validarNota(venda, 'NFE'), 5000);
      }
      else {
        console.error('Erro inesperado:', error);
      }
    }

  };


  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };
      axios
        .get(
          `${api.techfood}/v1/restaurantes/usuario/${idUser}`,
          options,
        )
        .then(async restaurante => {
          setLoja(restaurante.data);
        });
    }
  }, [idUser, accessToken]);

  const getDataAtual = () => {
    const dataAtual = new Date();
    const dia = String(dataAtual.getDate()).padStart(2, '0');
    const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    const ano = dataAtual.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  const formatarDocumento = documento => {
    const documentoSemMascara = documento.replace(/\D/g, ''); // Remove caracteres não numéricos
    if (documentoSemMascara.length === 11) {
      // Se o documento tem 11 dígitos, é um CPF
      return documentoSemMascara.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
        '$1.$2.$3-$4',
      ); // Formato: XXX.XXX.XXX-XX
    } else if (documentoSemMascara.length === 14) {
      // Se o documento tem 14 dígitos, é um CNPJ
      return documentoSemMascara.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        '$1.$2.$3/$4-$5',
      ); // Formato: XX.XXX.XXX/XXXX-XX
    } else {
      // Caso contrário, retorna o documento original
      return documento;
    }
  };

  return (
    <div className="container">
      <header className="modal-header">
        <Button
          type="primary"
          onClick={() => { closeModal(); focarCodigoDeBarras(); }}
          style={{ backgroundColor: "black", borderColor: "black" }}
        >
          <span>Voltar para Venda</span>
        </Button>
        <h1>Finalizar Venda</h1>
      </header>
      {
        isModalVisibleConsumidor ? (

          <IdentificarConsumidor
            onClose={toggleModalIdentificarConsumidor}
            isVisible={isModalVisibleConsumidor}
            nomeDoCupom={setNomeCupom}
            documentoDoCupom={setDocumentoCupom}
            setConsumidorIdentificado={setConsumidorIdentificado}
            consumidorIdentificado={consumidorIdentificado}
            consumidor={consumidor}
            setConsumidor={setConsumidor}
            documentoIntegracao={documentoCupom}
            emailNota={emailNota}
            setEmailNota={setEmailNota}
            telefoneEnvio={telefoneEnvio}
            setTelefoneEnvio={setTelefoneEnvio}

          ></IdentificarConsumidor>

        ) :
          isModalVisiblePagamento ? (
            <PaymentScreen onClose={toggleModalPagamento}
              isVisible={isModalVisiblePagamento}
              precoTotal={precoTotal.toFixed(2)}
              setPagamentoConcluido={setPagamentoConcluido}
              setPagItem={setPagItem}
              pagamentos={pagamentos}
              setPagamentos={setPagamentos}
              idLoja={config.restaurante.id}
              formasDePagamento={formasDePagamento}
              totalPago={totalPago}
              setTotalPago={setTotalPago}
            ></PaymentScreen>
          ) : isModalVisibleParametros ? (<Parametros
            onClose={toggleModalParametros}
            isVisible={isModalVisibleParametros}
            precoTotal={precoTotal}
            setPagamentoConcluido={setPagamentoConcluido}
            setPagItem={setPagItem}
            pagamentos={pagamentos}
            setPagamentos={setPagamentos}
            setIndPag={setIndPag}
            indPag={indPag}
            parametros={parametros}
            setParametros={setParametros}
            mostrarCobranca={mostrarCobranca}
            setMostrarCobranca={setMostrarCobranca}
          >

          </Parametros>) :


            isModalVisibleAcresDesc ? (<AcrescimoDescontoTotal
              onClose={toggleModalAcresDesc}
              isVisible={isModalVisibleAcresDesc}
              precoTotal={precoTotal}
              setPagamentoConcluido={setPagamentoConcluido}
              setPagItem={setPagItem}
              pagamentos={pagamentos}
              setPagamentos={setPagamentos}
              acresDescFrete={acresDescFrete}
              setAcresDescFrete={setAcresDescFrete}
              produtos={produtos}
              setProdutos={setProdutos}
              CalcularTotais={CalcularTotais}
              subTotal={subTotal}
              setAcrescimoDescontosFreteConcluido={
                setAcrescimoDescontosFreteConcluido
              }></AcrescimoDescontoTotal>) :
              (
                loading ? (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 40, width: '100%' }}>
                    <Spin
                      spinning={loading}
                      tip={<span style={{ fontSize: 16, fontWeight: '500', color: '#333' }}>Carregando...</span>}
                      size="large"
                    />
                    {processamentoMsg && (
                      <span style={{ marginTop: 16, fontSize: 20, color: '#666' }}>{processamentoMsg}</span>
                    )}
                  </div>
                ) :
                  (<>
                    <div className="container-buttons">

                      <div className="row">
                        <button
                          className={`button ${consumidorIdentificado || documentoCupom ? 'button-success' : 'button-purple'}`}
                          onClick={toggleModalIdentificarConsumidor}
                        >
                          Identificar Consumidor
                        </button>
                      </div>


                      <div className="row">
                        <button className="button button-warning" onClick={() => { if (!travarAcrescimoDescFrete) { toggleModalAcresDesc() } }}>
                          Acréscimos e Descontos
                        </button>
                      </div>

                      <div className="row">
                        <button className="button button-dark" onClick={toggleModalPagamento}>
                          Pagamento
                        </button>
                      </div>
                      <div className="row">
                        <button className="button button-primary" onClick={toggleModalParametros}>
                          Parâmetros
                        </button>
                      </div>
                      <div className="row">
                        <button
                          className={`button ${!pagamentoConcluido || loading || (consumidor && (consumidor?.endereco?.ufEstado != loja?.endereco?.cidade?.estado && consumidor?.endereco?.ufEstado != null)) ? 'button-disabled' : 'button-success'}`}
                          onClick={emitirCupom}
                          disabled={!pagamentoConcluido || loading || (consumidor && (consumidor?.endereco?.ufEstado != loja?.endereco?.cidade?.estado && consumidor?.endereco?.ufEstado != null))}
                        >
                          {'Emitir Cupom'}
                        </button>
                      </div>

                      <div className="row">
                        <button
                          className={`button ${pagamentoConcluido && !loading && consumidor?.endereco ? 'button-success' : 'button-disabled'}`}
                          onClick={emitirCupomNFE}
                          disabled={!pagamentoConcluido || loading || !consumidor?.endereco}
                        >
                          {'Emitir Danfe'}
                        </button>
                      </div>
                    </div>


                    <div className="card_totais" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                      {/* Coluna esquerda: sempre exibida */}
                      <div>
                        <p style={estiloP}>{getDataAtual()}</p>
                        <p style={estiloP}>Documento: {documentoCupom ? formatarDocumento(documentoCupom) : consumidor?.documentoCpfCnpj ? formatarDocumento(consumidor?.documentoCpfCnpj) : ''}</p>
                        <p style={estiloP}>E-mail de Envio: {consumidor?.email || emailNota || ''}</p>
                        <p style={estiloP}>Telefone de Envio: {telefoneEnvio ? formatarTelefone(telefoneEnvio) : ''}</p>
                        <p style={estiloP}>Subtotal: {subTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                        <p style={estiloP}>Desconto: {totalDescontos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                        <p style={estiloP}>Acréscimos: {totalAcrescimos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                        <p style={estiloP}>Frete: {parseFloat(acresDescFrete.frete).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                        <p style={estiloP}>Total: {precoTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>


                        {parametros?.infCpl && (<p style={estiloObservacao}>Observação da Danfe: {parametros?.infCpl}</p>)}
                      </div>

                      {/* Coluna direita: só aparece se tiver consumidor */}
                      {consumidor && (
                        <div>
                          {consumidor?.endereco?.numero && <p style={estiloP}>Número: {consumidor.endereco.numero}</p>}
                          {consumidor?.endereco?.bairro && <p style={estiloP}>Bairro: {consumidor.endereco.bairro}</p>}
                          {consumidor?.endereco?.logradouro && <p style={estiloP}>Logradouro: {consumidor.endereco.logradouro}</p>}
                          {consumidor?.endereco?.cidade?.ibge && <p style={estiloP}>IBGE: {consumidor.endereco.cidade.ibge}</p>}
                          {consumidor?.endereco?.cidade?.nome && <p style={estiloP}>Cidade: {consumidor.endereco.cidade.nome}</p>}
                          {consumidor?.endereco?.ufEstado || consumidor?.endereco?.cidade?.estado && <p style={estiloP}>UF: {consumidor.endereco.ufEstado || consumidor?.endereco?.cidade?.estado}</p>}
                          {consumidor?.ie || consumidor?.documentoRgIE && <p style={estiloP}>Inscrição Estadual: : {consumidor?.ie || consumidor?.documentoRgIE}</p>}
                          {consumidor?.telefone && <p style={estiloP}>Telefone Cadastrado: {consumidor.telefone}</p>}
                          {consumidor?.email && <p style={estiloP}>E-mail Cadastrado: {consumidor?.email}</p>}

                        </div>
                      )}

                    </div>

                  </>)
              )
      }

    </div>
  );
};
const estiloP = {
  margin: "5px 0",
  fontWeight: "bold",
  fontSize: "14px",
  width: "100%",
  whiteSpace: "pre-wrap",    // mantém quebras e força quebra automática
  wordBreak: "break-word",   // força quebra em palavras longas
  overflowWrap: "break-word" // extra segurança
};
const estiloObservacao = {
  ...estiloP,
  maxHeight: "150px",  // limita a altura visível
  overflowY: "auto",   // adiciona scroll vertical se passar disso
};
export default FinalizarVenda;